<!-- FILE GENERATED BY packages/components/design-tokens/build-scripts/generate-icons.js DO NOT CHANGE -->

<svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    data-token-name="IconArrowLeft_16"
    viewBox="0 0 16 16"
    aria-hidden="true"
>
    <path
        fill="currentColor"
        d="M13 7H6.079l1.797-3.616a.65.65 0 0 0-1.042-.748L1.929 7.541a.65.65 0 0 0 0 .919l4.905 4.905a.65.65 0 0 0 1.042-.749L6.079 9H13a1 1 0 0 0 0-2"
    />
</svg>
